interface IConfig {
  [key:string]: {
    production: boolean;
    apiURL: string;
    quizURL: string;
    shareURL: string;
    proceedClickBonusPoints: number;
    ipInfoUrl: string;
    autoRetryFetch: {
      timeout: number;
      count: number;
    },
    sentryDsn: string;
  }
}

const config:IConfig = {
  'development': {
    production: false,
    apiURL: 'http://api.quizwizards.test/api',
    quizURL: 'http://app.quizwizards.test',
    shareURL: 'http://api.quizwizards.test/share',
    proceedClickBonusPoints: 500,
    ipInfoUrl: 'https://ipinfo.io/json',
    autoRetryFetch: {
      timeout: 500,
      count: 3
    },
    sentryDsn: 'https://072b0cc607c20920998ef44c28607e21@o4509356281888768.ingest.us.sentry.io/4509356453003264'
  },
  'staging': {
    production: false,
    apiURL: 'https://api-staging.quizwizards.com/api',
    quizURL: 'https://app-staging.quizwizards.com',
    shareURL: 'https://api-staging.quizwizards.com/share',
    proceedClickBonusPoints: 500,
    ipInfoUrl: 'https://ipinfo.io/json',
    autoRetryFetch: {
      timeout: 500,
      count: 3
    },
    sentryDsn: 'https://072b0cc607c20920998ef44c28607e21@o4509356281888768.ingest.us.sentry.io/4509356453003264'
  },
  'production': {
    production: true,
    apiURL: 'https://api.quizwizards.com/api',
    quizURL: 'https://app.quizwizards.com',
    shareURL: 'https://api.quizwizards.com/share',
    proceedClickBonusPoints: 500,
    ipInfoUrl: 'https://ipinfo.io/json',
    autoRetryFetch: {
      timeout: 500,
      count: 3
    },
    sentryDsn: 'https://072b0cc607c20920998ef44c28607e21@o4509356281888768.ingest.us.sentry.io/4509356453003264'
  }
}

export const stage:string = process.env.REACT_APP_STAGE || 'development';

export default config[stage];